const Actions = {
  Signup: "signup",
  LearnMore: "learnmore",
  Download: "download",
  Click: "Click",
  GetInTouch: "getintouch",
  VideoPlay: "Play",
  VideoEnded: "End",
  VideoPause: "Pause",
  VideoResume: "Resume",
  VideoTimelineJump: "Timeline Jump",
  VideoTimeUdate: "VideoTimeUdate",
  VideoError: "Video Error",
  FormSubmitted: "Submitted",
}

const Events = {
  Forms: "F",
  Video: "Video",
  Login: "LoginClicked",
}

const Categories = {
  VideoJS: "VideoJS",
  Form: "Form",
}

export { Actions, Events, Categories }
